import { DisclaimerAssests } from './types/disclaimer.types';
import leftArrow from './assets/left-arrow.svg';
import attentionIcon from './assets/attention-icon.svg';

export const DISCLIAMER_ASSETS: DisclaimerAssests = {
  LEFT_ARROW: leftArrow,
  ATTENTION_ICON: attentionIcon,
};
